import { atom } from 'jotai';
import { BrokerNerdsBarkerCoreModelsAdministrativePrincipal, BrokerNerdsBarkerCoreModelsAdministrativeTenantDetails } from '../api';

export namespace auth {
  export const apiTokenAtom = atom<string | null>(null);
  export const tenantsAtom = atom<BrokerNerdsBarkerCoreModelsAdministrativeTenantDetails[]>([]);
  export const principalAtom = atom<BrokerNerdsBarkerCoreModelsAdministrativePrincipal | null | undefined>(null);
}
